import React from 'react';
import exact from 'prop-types-exact';
import queryString from 'query-string';

import { routerProps } from '../../../../propTypes';

import CenterLayout from '../../../../layouts/CenterLayout';
import PasswordResetRequestSuccess from './PasswordResetRequestSuccess';
import LayoutWithEmbeddedForm from './LayoutWithEmbeddedForm';

const SUCCESS = 'success';
const PasswordResetRequest = (props) => {
  const renderComponent = () => {
    const { location: { search } } = props;
    const querySringObject = queryString.parse(search);
    const isSuccess = querySringObject.state;

    if (isSuccess === SUCCESS) {
      return (<CenterLayout render={() => { return <PasswordResetRequestSuccess />; }} />);
    }
    return (
      <CenterLayout render={() => { return <LayoutWithEmbeddedForm />; }} />
    );
  };

  return (
    <div>
      {renderComponent()}
    </div>
  );
};

PasswordResetRequest.propTypes = exact({
  ...routerProps,
});

export default PasswordResetRequest;
